export const OPERATION_ICON_MAP = {
    // 复制
    fuzhi: {
        type: 'icon-fuzhi',
        border: false
    },
    // 编辑
    bianji: {
        type: 'icon-bianji1',
        border: false
    },
    // 加密
    jiami: {
        type: 'icon-jiami',
        border: false
    },
    // 解密
    jiemi: {
        type: 'icon-jiemi',
        border: false
    },
    // 设置
    shezhi: {
        type: 'icon-shezhi2',
        border: false
    },
    // 分享
    fenxiang: {
        type: 'icon-fenxiang1',
        border: false
    },
    // 删除
    shanchu: {
        type: 'icon-shanchu2',
        border: false
    },
    // 打印
    dayin: {
        type: 'icon-printer-line1',
        border: false
    },
    // 排除
    paichu: {
        type: 'icon-paichu',
        border: true,
        style: {
            width: '32px'
        },
        iconStyle: {
            fontSize: '24px'
        }
    },
    // 详、详情
    xiang: {
        type: 'icon-xiang',
        border: true
    },
    // 踪
    zong: {
        type: 'icon-zong',
        border: true
    },
    // 换
    huan: {
        type: 'icon-huan',
        border: true
    },
    // 补
    bu: {
        type: 'icon-bu',
        border: true
    },
    xiangNew: {
        type: 'icon-chakangengduo',
        border: false
    },
    // 日志
    rizhi: {
        type: 'icon-rizhi1',
        border: true,
        style: {
            width: '32px'
        },
        iconStyle: {
            fontSize: '24px'
        }
    },
    // text:自定义文字
    text: {
        type: 'text',
        border: true,
        style: {
            width: 'auto'
        }
    }
}
